import { URL_CODEBOOKS, URL_COST_CENTERS } from '../../router/constants';
import PermissionsService, {
  PERMISSION_COST_CENTERS,
  PERMISSION_PARKING_TAG,
  PERMISSION_RIDE_TAG,
} from '../../Services/PermissionsService';
import {
  TABLE_CODEBOOKS_PARKING,
  TABLE_CODEBOOKS_RIDE,
  TABLE_COST_CENTERS,
} from '../../Services/TableService';
import { ITab } from '../TabComponent/interfaces';

export const tabsByPermission = (
  tabs: string[],
  active: string,
  selectedCustomers: number[]
): ITab[] => {
  const enabledTabs: ITab[] = [];
  tabs.forEach((tabItem: string) => {
    if (
      tabItem === TABLE_CODEBOOKS_RIDE &&
      PermissionsService.hasAccess(PERMISSION_RIDE_TAG, ['read'], selectedCustomers)
    ) {
      enabledTabs.push({
        name: tabItem,
        isActive: tabItem === active,
        url: `${URL_CODEBOOKS}/ride-tag`,
      });
    }
    if (
      tabItem === TABLE_CODEBOOKS_PARKING &&
      PermissionsService.hasAccess(PERMISSION_PARKING_TAG, ['read'], selectedCustomers)
    ) {
      enabledTabs.push({
        name: tabItem,
        isActive: tabItem === active,
        url: `${URL_CODEBOOKS}/parking-tag`,
      });
    }
    if (
      tabItem === TABLE_COST_CENTERS &&
      PermissionsService.hasAccess(PERMISSION_COST_CENTERS, ['read'], selectedCustomers)
    ) {
      enabledTabs.push({
        name: tabItem,
        isActive: tabItem === active,
        url: `${URL_CODEBOOKS}${URL_COST_CENTERS}`,
      });
    }
  });
  return enabledTabs;
};
